import { TmdxResourceCard } from '@features/components/ResourceCards';
import { useContext } from 'react';
import { AuthContext } from '@lp/core/auth';
import { CaseDetailsPermissions } from '@/permissions';
import { getFullName } from '@/utils/helpers';
import { DriverInfo } from '@/utils/route';
import { AircraftLogisticsResourceType } from '@/api/apis/route';
import { getLegCrewTitle, PilotInfo } from '../../utils';
import { AircraftCard } from '../AircraftCard';

type LogisticResourcesProps = {
  aircrafts: AircraftLogisticsResourceType[];
  pilots: PilotInfo[];
  drivers: DriverInfo[];
};

export const RouteResources = ({ aircrafts, pilots, drivers }: LogisticResourcesProps) => {
  const { checkPermission } = useContext(AuthContext);
  const hasViewPilotsPermission = checkPermission(CaseDetailsPermissions.CasePilotsRead);
  const hasViewPilotsPhoneNumberPermission = checkPermission(CaseDetailsPermissions.CasePilotsPhoneNumberRead);

  return (
    <>
      {aircrafts?.map(({ resourceId }) => (
        <AircraftCard key={resourceId} aircraftId={resourceId} />
      ))}
      {hasViewPilotsPermission &&
        pilots.map((p) => (
          <div key={p.phone} className="w-80">
            <TmdxResourceCard
              menuDisabled
              showChip={false}
              list={[]}
              type="user"
              title={getFullName(p.firstName, p.lastName)}
              subTitle={getLegCrewTitle(p.type)}
              phoneNumber={hasViewPilotsPhoneNumberPermission ? p.phone : ''}
            />
          </div>
        ))}
      {drivers.map((d) => (
        <div key={d.driver} className="w-80">
          <TmdxResourceCard
            menuDisabled
            showChip={false}
            list={[]}
            type="user"
            title={d.driver}
            subTitle={getLegCrewTitle(d.type)}
            phoneNumber={d.contact}
          />
        </div>
      ))}
    </>
  );
};
